/**
 * Created by anatoly on 01.06.2026
 */

const NewLevelsWindow = Prefab.createWindow("new_levels_window", "new_levels_window_prefab_json");

NewLevelsWindow.canShow = function () {
    const user = cleverapps.user;

    return user && user.currentPhysicalLevel && user.currentPhysicalLevel.progress > 0
        && !user.isPlayingFakeLevels()
        && !cleverapps.dataLoader.load(DataLoader.TYPES.NEW_LEVELS_EXPLANATION_SHOWN);
};
